<template>
    <client-page class="app--main grey darken-4">
        <full-page ref="fullpage" :options="fullpageOptions" id="fullpage">
            <!-- S: 메인비주얼 -->
            <div class="section">
                <div class="main-visual">
                    <swiper class="swiper" :options="swiperOptions">
                        <swiper-slide class="d-flex align-center">
                            <v-container>
                                <div class="tit-wrap tit-wrap--sm overflow-hidden">
                                    <h3 data-aos="fade-up" class="tit tit--xs font-weight-semibold font-secondary primary--text">Farming Tomorrow</h3>
                                </div>
                                <div class="tit-wrap overflow-hidden">
                                    <h3 data-aos="fade-up" data-aos-delay="100" class="tit tit--xxl font-weight-regular"><b>이레아이에스</b>는 <br class="d-none d-md-block" />스마트팜의 근본인 농업을 연구합니다.</h3>
                                </div>
                                <div data-aos="fade-up" data-aos-delay="200">
                                    <v-btn large color="white" to="/about#about" class="v-btn--width-fixed">더 알아보기</v-btn>
                                </div>
                            </v-container>
                            <div class="swiper-slide__bg" style="background-image:url(/images/main/v1.jpg);"></div>
                        </swiper-slide>
                        <swiper-slide class="d-flex align-center">
                            <v-container>
                                <div class="tit-wrap tit-wrap--sm overflow-hidden">
                                    <h3 data-aos="fade-up" class="tit tit--xs font-weight-semibold font-secondary primary--text">Farming Tomorrow</h3>
                                </div>
                                <div class="tit-wrap overflow-hidden">
                                    <h3 data-aos="fade-up" data-aos-delay="100" class="tit tit--xxl font-weight-regular"><b>미래농업</b>의 <b>비전</b>을 제시하고 <br class="d-none d-md-block" />농업 기술의 발전을 선도하는 기업이 되겠습니다.</h3>
                                </div>
                                <div data-aos="fade-up" data-aos-delay="200">
                                    <v-btn large color="white" to="/solution/smartfarm/rmfarm#rmfarm" class="v-btn--width-fixed">더 알아보기</v-btn>
                                </div>
                            </v-container>
                            <div class="swiper-slide__bg" style="background-image:url(/images/main/v2.jpg);"></div>
                        </swiper-slide>
                        <swiper-slide class="d-flex align-center">
                            <v-container>
                                <div class="tit-wrap tit-wrap--sm overflow-hidden">
                                    <h3 data-aos="fade-up" class="tit tit--xs font-weight-semibold font-secondary primary--text">Farming Tomorrow</h3>
                                </div>
                                <div class="tit-wrap overflow-hidden">
                                    <h3 data-aos="fade-up" data-aos-delay="100" class="tit tit--xxl font-weight-regular"><b>농업</b>과 <b>IT기술</b>의 컨버전스로 <br class="d-none d-md-block" />미래의 먹거리 혁신을 주도합니다.</h3>
                                </div>
                                <div data-aos="fade-up" data-aos-delay="200">
                                    <v-btn large color="white" to="/technology#technology" class="v-btn--width-fixed">더 알아보기</v-btn>
                                </div>
                            </v-container>
                            <div class="swiper-slide__bg" style="background-image:url(/images/main/v3.jpg);"></div>
                        </swiper-slide>
                        <swiper-slide class="d-flex align-center">
                            <v-container>
                                <div class="tit-wrap tit-wrap--sm overflow-hidden">
                                    <h3 data-aos="fade-up" class="tit tit--xs font-weight-semibold font-secondary primary--text">Farming Tomorrow</h3>
                                </div>
                                <div class="tit-wrap overflow-hidden">
                                    <h3 data-aos="fade-up" data-aos-delay="100" class="tit tit--xxl font-weight-regular"><b>재배</b>부터 <b>유통</b>까지 여러분의 <br class="d-none d-md-block" />안전하고 건강한 식탁을 책임집니다.</h3>
                                </div>
                                <div data-aos="fade-up" data-aos-delay="200">
                                    <v-btn large color="white" to="/business#business" class="v-btn--width-fixed">더 알아보기</v-btn>
                                </div>
                            </v-container>
                            <div class="swiper-slide__bg" style="background-image:url(/images/main/v4.jpg);"></div>
                        </swiper-slide>
                        <div class="swiper-control">
                            <div class="swiper-pagination" slot="pagination"></div>
                        </div>
                    </swiper>
                </div>
            </div>
            <!-- E: 메인비주얼 -->

            <!-- S: business -->
            <div class="section section--business grey darken-4">
                <section class="main-section">
                    <v-container>
                        <v-row align="center">
                            <v-col cols="12" md="5">
                                <div class="tit-wrap tit-wrap--sm overflow-hidden">
                                    <h3 data-aos="fade-up" class="tit tit--xs font-weight-semibold font-secondary primary--text">Business</h3>
                                </div>
                                <div class="overflow-hidden mb-8px">
                                    <h3 data-aos="fade-up" data-aos-delay="100" class="tit tit--xxl">비즈니스</h3>
                                </div>
                                <div class="tit-wrap overflow-hidden">
                                    <div data-aos="fade-up" data-aos-delay="200" class="tit tit--sm font-weight-regular line-height-15">Farm to Table! <br class="d-none d-md-block" />농장설치, 재배 관리, 신선유통까지 <br class="d-none d-md-block" />스마트팜 통합 솔루션을 제공합니다.</div>
                                </div>
                                <div data-aos="fade-up" data-aos-delay="300">
                                    <v-btn large color="white" to="/business#business" class="v-btn--width-fixed">더 알아보기</v-btn>
                                </div>
                            </v-col>
                            <v-col cols="12" md="7">
                                <div class="mt-20px mt-md-0px">
                                    <v-row>
                                        <v-col data-aos="fade-left" data-aos-delay="100" cols="12" md="6">
                                            <v-card img="/images/main/business-img.jpg" class="rounded-tl">
                                                <v-responsive :aspect-ratio="$vuetify.breakpoint.mdAndUp ? 334 / 286 : ''">
                                                    <div class="pa-32px">
                                                        <div class="tit tit--xs white--text">솔루션</div>
                                                    </div>
                                                </v-responsive>
                                            </v-card>
                                        </v-col>
                                        <v-col data-aos="fade-left" data-aos-delay="200" cols="12" md="6">
                                            <v-card tile img="/images/main/business-img2.jpg">
                                                <v-responsive :aspect-ratio="$vuetify.breakpoint.mdAndUp ? 334 / 286 : ''">
                                                    <div class="pa-32px">
                                                        <div class="tit tit--xs white--text">시설</div>
                                                    </div>
                                                </v-responsive>
                                            </v-card>
                                        </v-col>
                                        <v-col data-aos="fade-left" data-aos-delay="300" cols="12" md="6">
                                            <v-card tile img="/images/main/business-img3.jpg">
                                                <v-responsive :aspect-ratio="$vuetify.breakpoint.mdAndUp ? 334 / 286 : ''">
                                                    <div class="pa-32px">
                                                        <div class="tit tit--xs white--text">재배</div>
                                                    </div>
                                                </v-responsive>
                                            </v-card>
                                        </v-col>
                                        <v-col data-aos="fade-left" data-aos-delay="400" cols="12" md="6">
                                            <v-card img="/images/main/business-img4.jpg" class="rounded-br">
                                                <v-responsive :aspect-ratio="$vuetify.breakpoint.mdAndUp ? 334 / 286 : ''">
                                                    <div class="pa-32px">
                                                        <div class="tit tit--xs white--text">서비스</div>
                                                    </div>
                                                </v-responsive>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </section>
            </div>
            <!-- E: business -->

            <!-- S: technology -->
            <div class="section" style="background-image:url(/images/main/technology-bg.jpg);">
                <section class="main-section text-center">
                    <v-container>
                        <div data-aos="fade-up" data-aos-delay="100" class="mb-30px mb-md-40px">
                            <v-img :aspect-ratio="1 / 1" max-width="120" src="/images/icon/icon-expand.png" class="mx-auto" />
                        </div>
                        <div class="tit-wrap tit-wrap--sm overflow-hidden">
                            <h3 data-aos="fade-up" data-aos-delay="100" class="tit tit--xs font-weight-semibold font-secondary primary--text">Core technology</h3>
                        </div>
                        <div class="overflow-hidden mb-8px">
                            <h3 data-aos="fade-up" data-aos-delay="200" class="tit tit--xxl">핵심기술 = 근권부 + 빅데이터</h3>
                        </div>
                        <div class="tit-wrap overflow-hidden">
                            <div data-aos="fade-down" data-aos-delay="200" class="tit tit--sm font-weight-regular line-height-15">농업의 핵심은 작물의 뿌리입니다. <br class="d-none d-md-block" />국내 최고 수준의 근권부 측정 기술을 보유하고 있습니다.</div>
                        </div>
                        <div data-aos="zoom-in" data-aos-delay="300">
                            <v-btn large color="white" to="/technology#technology" class="v-btn--width-fixed mx-auto">더 알아보기</v-btn>
                        </div>
                    </v-container>
                </section>
            </div>
            <!-- E: technology -->

            <!-- S: bigdata -->
            <div class="section" style="background-image:url(/images/main/bigdata-bg.jpg);">
                <section class="main-section text-center">
                    <v-container>
                        <div class="tit-wrap tit-wrap--sm overflow-hidden">
                            <h3 data-aos="fade-up" class="tit tit--xs font-weight-semibold font-secondary primary--text">Big data</h3>
                        </div>
                        <div class="tit-wrap tit-wrap--lg overflow-hidden">
                            <h3 data-aos="fade-up" data-aos-delay="100" class="tit tit--xxl">빅데이터</h3>
                        </div>
                        <div style="border-top:1px solid rgba(255,255,255,0.2);border-bottom:1px solid rgba(255,255,255,0.2)" class="py-20px py-md-40px">
                            <v-row class="row-cols-md-5 text-center">
                                <v-col cols="6" sm="4" md="">
                                    <div class="tit tit--xl font-secondary mb-10px mb-md-16px"><ICountUp ref="countUp" :delay="delay" :endVal="main.domesitc" :options="countUpOptions" class="countup" />+</div>
                                    <div data-aos="fade-up" data-aos-delay="200" class="tit tit--sm font-weight-regular line-height-13">(주)이레아이에스 <br class="d-none d-md-block" />국내 사용지역</div>
                                </v-col>
                                <v-col cols="6" sm="4" md="">
                                    <div class="tit tit--xl font-secondary mb-10px mb-md-16px"><ICountUp ref="countUp2" :delay="delay" :endVal="main.overseas" :options="countUpOptions" class="countup" />+</div>
                                    <div data-aos="fade-up" data-aos-delay="200" class="tit tit--sm font-weight-regular line-height-13">(주)이레아이에스 <br class="d-none d-md-block" />해외 사용지역</div>
                                </v-col>
                                <v-col cols="6" sm="4" md="">
                                    <div class="tit tit--xl font-secondary mb-10px mb-md-16px"><ICountUp ref="countUp3" :delay="delay" :endVal="main.farmhouse" :options="countUpOptions" class="countup" />+</div>
                                    <div data-aos="fade-up" data-aos-delay="200" class="tit tit--sm font-weight-regular line-height-13">사용 농가</div>
                                </v-col>
                                <v-col cols="6" sm="4" md="">
                                    <div class="tit tit--xl font-secondary mb-10px mb-md-16px">
                                        <ICountUp ref="countUp4" :delay="delay" :endVal="main.data" :options="countUpOptions" class="countup" />
                                    </div>
                                    <div data-aos="fade-up" data-aos-delay="200" class="tit tit--sm font-weight-regular line-height-13">농가 데이터 센서 수</div>
                                </v-col>
                                <v-col cols="6" sm="4" md="">
                                    <div class="tit tit--xl font-secondary mb-10px mb-md-16px"><ICountUp ref="countUp5" :delay="delay" :endVal="main.dataCollection" :options="countUpOptions2" class="countup" />억</div>
                                    <div data-aos="fade-up" data-aos-delay="200" class="tit tit--sm font-weight-regular line-height-13">1일 데이터 수집량</div>
                                </v-col>
                            </v-row>
                        </div>
                    </v-container>
                </section>
            </div>
            <!-- E: bigdata -->

            <!-- S: product -->
            <div class="section grey darken-4">
                <section class="main-section">
                    <v-container>
                        <v-row align="center">
                            <v-col cols="12" md="6" order-md="2">
                                <div data-aos="fade-up">
                                    <v-img max-width="588" :aspect-ratio="588 / 280" src="/images/main/product-img.png" class="mx-auto" />
                                </div>
                            </v-col>
                            <v-col cols="12" md="6" order-md="1">
                                <div class="tit-wrap tit-wrap--sm overflow-hidden">
                                    <h3 data-aos="fade-up" class="tit tit--xs font-weight-semibold font-secondary primary--text">Product Descriptions</h3>
                                </div>
                                <div class="overflow-hidden mb-8px">
                                    <h3 data-aos="fade-up" data-aos-delay="100" class="tit tit--xxl">제품소개</h3>
                                </div>
                                <div class="tit-wrap overflow-hidden">
                                    <div data-aos="fade-up" data-aos-delay="200" class="tit tit--sm font-weight-regular line-height-15">농업의 미래를 선도하는 기업, <br class="d-none d-md-block" />혁신적인 기술과 전문성으로 <br class="d-none d-md-block" />친환경적인 스마트팜 혁신을 선도하고 있습니다.</div>
                                </div>
                                <div data-aos="fade-up" data-aos-delay="300">
                                    <v-btn large color="white" to="/solution/smartfarm/rmfarm#rmfarm" class="v-btn--width-fixed">더 알아보기</v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </section>
            </div>
            <!-- E: product -->

            <!-- S: farming -->
            <!-- <div class="section section--farming" style="background-image:url(/images/main/farming-bg.jpg);">
                <section class="main-section">
                    <v-container>
                        <v-row align="center">
                            <v-col cols="12">
                                <div class="tit-wrap tit-wrap--sm overflow-hidden">
                                    <h3 data-aos="fade-up" class="tit tit--xs font-weight-semibold font-secondary primary--text">Farming to Table</h3>
                                </div>
                                <div class="overflow-hidden mb-8px">
                                    <h3 data-aos="fade-up" data-aos-delay="100" class="tit tit--xxl font-sh">팜이레몰</h3>
                                </div>
                                <div class="tit-wrap overflow-hidden">
                                    <div data-aos="fade-up" data-aos-delay="200" class="tit tit--sm font-weight-regular line-height-15">팜이레는 스마트팜에서 재배한 <br class="d-none d-md-block" />건강하고 영양가 높은 먹거리를 <br class="d-none d-md-block" />여러분의 식탁까지 안전하게 책임집니다.</div>
                                </div>
                                <div data-aos="fade-up" data-aos-delay="300">
                                    <v-btn large color="primary" href="http://shopire.kr/" target="_blank" class="v-btn--width-fixed">쇼핑몰가기</v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </section>
            </div> -->
            <!-- E: farming -->

            <!-- S: contactus -->
            <div class="section fp-auto-height" style="background-image:url(/images/main/contactus-bg.jpg);">
                <section class="py-40px py-md-60px py-lg-80px text-center">
                    <v-container>
                        <div data-aos="zoom-in">
                            <v-btn outlined color="white" to="/community/inquire" class="v-size--xx-large font-secondary rounded-0">Contact us</v-btn>
                        </div>
                        <div data-aos="fade-up" data-aos-delay="100" class="mw-1000px mt-30px mt-md-40px mx-auto">
                            <v-row align="center" justify="center" justify-md="space-around" class="text-center">
                                <v-col cols="auto">
                                    <router-link to="/community/inquire" class="tit tit--xs font-weight-regular font-secondary primary--text">Smart Farm</router-link>
                                </v-col>
                                <v-col cols="auto" class="align-self-stretch d-none d-md-block">
                                    <v-divider vertical class="h-100" style="border-color:rgba(255,255,255,0.2);" />
                                </v-col>
                                <v-col cols="auto">
                                    <router-link to="/community/inquire" class="tit tit--xs font-weight-regular font-secondary primary--text">Turnkey Greenhouses</router-link>
                                </v-col>
                                <v-col cols="auto" class="align-self-stretch d-none d-md-block">
                                    <v-divider vertical class="h-100" style="border-color:rgba(255,255,255,0.2);" />
                                </v-col>
                                <v-col cols="auto">
                                    <router-link to="/community/inquire" class="tit tit--xs font-weight-regular font-secondary primary--text">Fresh Food</router-link>
                                </v-col>
                                <v-col cols="auto" class="align-self-stretch d-none d-md-block">
                                    <v-divider vertical class="h-100" style="border-color:rgba(255,255,255,0.2);" />
                                </v-col>
                                <v-col cols="auto">
                                    <router-link to="/community/inquire" class="tit tit--xs font-weight-regular font-secondary primary--text">General</router-link>
                                </v-col>
                            </v-row>
                        </div>
                    </v-container>
                </section>
            </div>
            <!-- E: contactus -->

            <!-- S: Footer -->
            <div class="section section--footer fp-auto-height d-none d-xl-table">
                <main-footer />
            </div>
            <!-- E: Footer -->
        </full-page>

        <popup-layer></popup-layer>
    </client-page>
</template>

<script>
import api from "@/api";
import ICountUp from "vue-countup-v2";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import MainFooter from "@/components/client/inc/main-footer.vue";
import PopupLayer from "@/components/client/popup/popup-layer.vue";

export default {
    components: {
        ICountUp,
        Swiper,
        SwiperSlide,

        ClientPage,
        MainFooter,
        PopupLayer,
    },
    props: {},
    data() {
        return {
            fullpageOptions: {
                licenseKey: "BE202675-E3234C07-967F61A1-57A110B1",
                // anchors: ["mainvisual", "business", "technology", "bigdata", "product", "farming", "contactus", "footer"],
                fitToSection: true,
                scrollOverflow: true,
                scrollingSpeed: 700,
                responsiveWidth: 1200,
                responsiveHeight: 800,
                onLeave: this.onLeave,
                afterLoad: this.afterLoad,
            },
            // endVal: 80,
            // endVal2: 8,
            // endVal3: 1200,
            // endVal4: 55000,
            // endVal5: 2.5,
            main: {
                domesitc: 80,
                overseas: 8,
                farmhouse: 1200,
                data: 55000,
                dataCollection: 2.5,
            },
            delay: 1000,
            countUpOptions: {
                useEasing: true,
                useGrouping: true,
                separator: ",",
                decimal: ".",
                prefix: "",
                suffix: "",
                enableScrollSpy: true,
                scrollSpyOnce: true,
            },
            countUpOptions2: {
                useEasing: true,
                useGrouping: true,
                separator: ",",
                decimal: ".",
                prefix: "",
                suffix: "",
                enableScrollSpy: true,
                scrollSpyOnce: true,
                decimalPlaces: 1,
            },
            swiperOptions: {
                effect: "fade",
                allowTouchMove: true,
                centeredSlides: true,
                spaceBetween: 0,
                autoplay: {
                    delay: 6000,
                    disableOnInteraction: false,
                },
                speed: 500,
                loop: true,
                pagination: {
                    el: ".main-visual .swiper-pagination",
                    clickable: true,
                },
                on: {
                    slideChangeTransitionStart: function() {
                        var visual = document.querySelector(".main-visual");
                        var slide = visual.querySelector(".swiper-slide-active");
                        var slideAos = slide.querySelectorAll(".aos-init");
                        slideAos.forEach((item) => {
                            item.style.display = "none";
                            item.classList.remove("aos-animate");
                        });
                    },
                    slideChangeTransitionEnd: function() {
                        var visual = document.querySelector(".main-visual");
                        var slide = visual.querySelector(".swiper-slide-active");
                        var slideAos = slide.querySelectorAll(".aos-init");
                        slideAos.forEach((item) => {
                            item.style.display = "";
                        });
                        AOS.init();
                    },
                },
            },
        };
    },
    computed: {
        swiper() {
            return this.$refs.mainVisualSwiper.$swiper;
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            let { main } = await api.v1.ireis.main.get();
            if (main) this.main = main;
            console.log(this.main);
        },

        onLeave: function() {
            this.$refs.countUp.reset();
            this.$refs.countUp2.reset();
            this.$refs.countUp3.reset();
            this.$refs.countUp4.reset();
            this.$refs.countUp5.reset();
        },
        afterLoad: function() {
            this.$refs.countUp.start();
            this.$refs.countUp2.start();
            this.$refs.countUp3.start();
            this.$refs.countUp4.start();
            this.$refs.countUp5.start();

            document.querySelectorAll(".fp-table.active .aos-init").forEach((el) => {
                el.classList.add("aos-animate");
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.fp-section {
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}
.fp-responsive{
    .section--footer{
        display: none !important;
    }
}

.main-visual {
    position: relative;
    width: 100vw;
    height: 100vh;
    color: #fff;
    .swiper-container,
    .swiper-wrapper,
    .swiper-slide {
        height: 100%;
    }
    .swiper-slide {
        background-color: var(--v-grey-lighten5);
        &__bg {
            width: 100vw;
            height: 100vh;
        }
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}

.main-section {
    width: 100vw;
    color: #fff;
    .v-card {
        &.rounded-tl {
            border-radius: 20px 0 0 0 !important;
        }
        &.rounded-br {
            border-radius: 0 0 20px 0 !important;
        }
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .main-section {
        .v-card {
            &.rounded-tl {
                border-radius: 40px 0 0 0 !important;
            }
            &.rounded-br {
                border-radius: 0 0 40px 0 !important;
            }
        }
    }
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}

@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .section--business {
        .main-section {
            padding: calc(var(--header-body) + 60px) 0 60px;
        }
    }
}
@media (min-width: 1200px) {
}

.section--farming {
    position: relative;
    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
    .section--farming {
        &::before {
            display: none;
        }
    }
}
</style>
